module.exports = __webpack_public_path__ + "img/keyboard.53c90cd8.png";